import * as Yup from 'yup'

import { ProjectWorkflowState } from 'src/types/project'

export const validationSchema = Yup.object({
  Id: Yup.string(),
  Name: Yup.string().required('This field is required'),
  Description: Yup.string(),
  Area: Yup.string().required('This field is required'),
  Hero: Yup.string().required(),
  HeroFile: Yup.array(),
  PlantingTimeframes: Yup.string().required('This field is required'),
  ProjectAssets: Yup.array().of(Yup.mixed().required()),
  Geo: Yup.object()
    .nullable()
    .test('Geo', 'Please provide a valid address', v => {
      if (!v || !v.lat || !v.lng || !v.place_id) {
        return false
      }
      return true
    }),
  District: Yup.string().nullable().optional(),
  Region: Yup.string().nullable().optional(),
  Purpose: Yup.array(Yup.string()).max(3, 'Select no more than 3 items'),
  LandUse: Yup.array(Yup.string()).required('This field is required'),
  LandUseOther: Yup.string(),
  OtherLandArea: Yup.string(),
  WebsiteLinks: Yup.array()
    .of(Yup.string().url('Must be a valid website'))
    .optional(),
  NumberOfProperties: Yup.string().required('This field is required'),
  WorkflowState: Yup.string().oneOf([
    ProjectWorkflowState.Draft,
    ProjectWorkflowState.Submitted
  ])
})
